import { LicenseInfo } from '@mui/x-license-pro';

const licenseKey = process.env.REACT_APP_MUI_PRO_LICENSE_KEY;

if (licenseKey) {
  LicenseInfo.setLicenseKey(licenseKey);
} else {
  console.warn('MUI X license not found.');
}
